import hacRelatedArticles from './hac-related-articles';

export const RELATED_ARTICLES = {
  entityName: 'mortgages_home_affordability_related_articles',
  sectionName: 'mortgages_home_affordability_related_articles',
  sectionPosition: 5,
  articles: hacRelatedArticles,
};
